var LocaleUtils = require('./util/localeUtils');

if (window && !window.$) { // this check is for SG, in SG window.$ is already exist and throw error on reinitialize
    window.jQuery = window.$ = require('jquery'); // eslint-disable-line
}

var $prCategorySnippets = $('.pr-category-snippet');
var $prWarForm = $('.pr-war-form');
var $prPdpComponents = $('.pr-pdp-components');

/* eslint-disable no-undef */

/**
 * @function prLoadCategorySnippets
 */
function prLoadCategorySnippets() {
    var prCategorySnippets = [];
    if ($prCategorySnippets.length > 0) {
        $($prCategorySnippets).each(function (index) { // eslint-disable-line
            if ($(this).data('pr-plp-component')) {
                prCategorySnippets.push($(this).data('pr-plp-component'));
            }
        });
    }
    if (prCategorySnippets.length > 0) {
        pwr('render', prCategorySnippets);
    }
}

/**
 * updateRatingDate
 * @param {*} $ratingDate jQuery element containing the rating date text to be updated
 */
function updateRatingDate($ratingDate) {
    if ($ratingDate.length) {
        var sourceDate = $ratingDate.text();
        var date = new Date(sourceDate);
        var $config = $('#locale-config');
        if ($config.length && !Number.isNaN(date.getTime())) {
            var pattern = $config.data('long-date-pattern');
            var formattedDate = LocaleUtils.formatDateWithPattern(date, pattern);
            $ratingDate.text(formattedDate);
        }
    }
}

/**
 * @function prLoadWarForm
 */
function prLoadWarForm() {
    if ($prWarForm.length > 0 && $prWarForm.data('pr-war-form')) {
        var prWarFormData = $prWarForm.data('pr-war-form');
        // add on_submit callback method
        prWarFormData.on_submit = function (config, data) { // eslint-disable-line
            window.scrollTo(0, 0);
            if (data.fields.length > 0) {
                var rating = data.fields.find(obj => obj.key === "rating");
                var productInfo = $('.product-for-gtm').data('gtm-product') || '';
                dataLayer.push({
                    'event': 'reviewSubmitted',
                    'rating': rating.value || '',
                    'ratedProduct': productInfo
                });
            }
            updateRatingDate($('.pr-rating-date'));
        };
        pwr('render', prWarFormData);
    }
}

/**
 * @function prLoadPdpComponents
 * @param {Object} powerReviewsData --powerReviewsData from product variant
 */
function prLoadPdpComponents(powerReviewsData) {
    if ($prPdpComponents.length > 0) {
        var prPdpData = powerReviewsData || $prPdpComponents.data('pr-pdp-components');
        pwr('render', prPdpData);
    }
}

/**
 * Prevents NVDA from announcing the PowerReviews star rating as "clickable graphic".
 * PowerReviews attaches a click handler to .pr-snippet-stars (for scroll-to-reviews),
 * which causes NVDA to announce it as interactive. This function:
 *   1. Waits for .pr-snippet-stars to be rendered by PowerReviews.
 *   2. Reads the accurate aria-label (e.g. "Rated 4.4 out of 5 stars") from it.
 *   3. Updates the .sr-only span in the parent .ratings container with that live value,
 *      replacing any stale server-rendered text.
 *   4. Sets aria-hidden="true" on .pr-snippet-stars so screen readers use only
 *      the now-accurate .sr-only text instead of the clickable widget.
 * @returns {void}
 */
function fixStarRatingAccessibility() {
    var snippetObserver = new MutationObserver(function (mutations, obs) {
        var $stars = $('.pr-snippet-stars');
        if ($stars.length) {
            obs.disconnect();
            $stars.each(function () {
                var $star = $(this);
                var ariaLabel = $star.attr('aria-label');
                if (ariaLabel) {
                    var $srOnly = $star.closest('.ratings').find('.sr-only');
                    if ($srOnly.length) {
                        $srOnly.text(ariaLabel);
                    }
                }
                $star.attr('aria-hidden', 'true');
            });
        }
    });
    snippetObserver.observe(document.body, { childList: true, subtree: true });
}

window.pwr = window.pwr || function () {
    (pwr.q = pwr.q || []).push(arguments);
};
 
/**
* Executes the core PowerReviews logic once the SDK is guaranteed to be loaded
*
* @param {JQuery<HTMLElement>} $form - The jQuery collection representing the Write-A-Review form.
* @returns {void}
*/
function executePowerReviewsLogic($form) {
 
    if ($form != null && $form.length > 0) {
 
        if (typeof prLoadWarForm === 'function') {
            prLoadWarForm();
        }
 
        var observerConfig = {
            childList: true,
            subtree: true
        };
 
        var hasInitialized = false;
        var debounceTimer = null;
 
        var observer = new MutationObserver(function (mutations) {
            if (hasInitialized) return;
 
            mutations.forEach(function (mutation) {
                if (mutation.type !== 'childList' || !mutation.addedNodes.length) return;
 
                clearTimeout(debounceTimer);
 
                debounceTimer = setTimeout(function () {
                    if (hasInitialized) return;
 
                    var $img = $('.pr-header-product-img');
                    if ($img.length && $form.length && $form.data('pr-war-form')) {
                        var colorSwatch = $form.data('pr-war-form').colorSwatch;
                        if (colorSwatch) {
                            $img.find('img').attr('src', colorSwatch);
                        }
                    }
 
                    var $link = $('.pr-header-product-name .pr-underline');
 
                    if ($link.length && $form.length && $form.data('pr-war-form')) {
                        var prWarFormData = $form.data('pr-war-form');
                        var returnUrl = prWarFormData.return_url;
 
                        $link.attr('href', returnUrl);
 
                        hasInitialized = true;
                        observer.disconnect();
                    }
                }, 100);
            });
        });
 
        observer.observe(document.body, observerConfig);
 
    } else {
        $(document).ajaxComplete(function (event, xhr, settings) {
            if (settings.url.includes('Search-UpdateGrid') || $('#search-result-items').length > 0 || $('#product-search-results').length > 0 || $('#content-search-results-pane').length > 0) {
                /* need to get new number of product
                divs if added new (#search-result-items is for SG) */
                $prCategorySnippets = $('.pr-category-snippet');
                prLoadCategorySnippets();
            }
            if ($('#product-content').length > 0) { // this is for SG PDP variant change
                $prPdpComponents = $('.pr-pdp-components');
                prLoadPdpComponents();
            }
        });
        if ($prCategorySnippets.length > 0) { // only fire if user is on PLP page
            prLoadCategorySnippets();
        }
        if ($prPdpComponents.length > 0) { // only fires if user is on PDP page
            prLoadPdpComponents();
        }
        fixStarRatingAccessibility();
        $('body').on('product:updateAvailability', function (e, response) {
            prLoadPdpComponents(response.product.powerReviewsComponents);
        });
    }
}

/**
* Initializes the PowerReviews suite integration.
* Employs a polling mechanism (setInterval) to wait for the `window.POWERREVIEW` configuration
* object to be available before executing PowerReviews rendering logic (Safari iPad/iOS + slow networks).
*
* @returns {void}
*/
function initPowerReviewsSuite() {
    var $form = (typeof $prWarForm !== 'undefined' && $prWarForm.length) ? $prWarForm : null;
 
    var checkCount = 0;
    var prPoller = setInterval(function () {
        checkCount++;
 
        if (window.POWERREVIEW) {
            clearInterval(prPoller);
            executePowerReviewsLogic($form); 
        }
 
        if (checkCount > 200) {
            clearInterval(prPoller);
            // eslint-disable-next-line no-console
            console.warn('PowerReviews SDK failed to load in time.');
        }
    }, 50);
}

$(document).ready(function () {
    initPowerReviewsSuite();
});